export class TextareaController {
    constructor(root, params = {}) {
        this._root = root;
        this._params = params;

        this._$textarea = root.querySelector('textarea') || root; // Because it depends if you plug the module to the actual textarea tag, or the parent
        this._isAutogrow = !!params.autogrow;

        this._toggleActiveClass = this._toggleActiveClass.bind(this);
        this._setActive = this._setActive.bind(this);
        this._computeHeight = this._computeHeight.bind(this);
    }

    _setActive() {
        this._root.classList.add('active');
    }

    _setInactive() {
        this._root.classList.remove('active');
    }

    _toggleActiveClass() {
        const textareaValue = this._$textarea.value;

        if (textareaValue) {
            this._setActive();
        } else {
            this._setInactive();
        }
    }

    _getInvisibleBlock() {
        // this block is made the calculate precisely the height of our textarea
        // As textarea has a specific resize mecanism, it's more precise to bind its height to a neutral div
        // This div needs to have the same font-size properties
        return this._root.querySelector('[data-textarea-height]');
    }

    _createHeightCalculatorElement() {
        const div = document.createElement('div');
        div.setAttribute('data-textarea-height', '');
        div.classList.add('m-textarea__height-calculator');
        this._root.appendChild(div);
    }

    _computeHeight() {
        if (!this._getInvisibleBlock()) {
            this._createHeightCalculatorElement();
        }

        this._getInvisibleBlock().innerText = this._$textarea.value;

        const style = this._$textarea.currentStyle || window.getComputedStyle(this._$textarea);
        const paddingTop = parseInt(style.paddingTop);
        const paddingBottom = parseInt(style.paddingBottom);

        this._$textarea.style.height = this._getInvisibleBlock().clientHeight + (paddingTop + paddingBottom) + 'px';
    }

    updateValue(value) {
        this._$textarea.value = value;
        this._computeHeight();
    }

    _addListeners() {
        this._$textarea.addEventListener('change', this._toggleActiveClass);
        this._$textarea.addEventListener('blur', this._toggleActiveClass);
        this._$textarea.addEventListener('focus', this._setActive);
        if (this._isAutogrow) {
            this._$textarea.addEventListener('input', this._computeHeight);
            this._computeHeight();
        }
    }

    _removeListeners() {
        this._$textarea.removeEventListener('change', this._toggleActiveClass);
        this._$textarea.removeEventListener('blur', this._toggleActiveClass);
        this._$textarea.removeEventListener('focus', this._setActive);

        if (this._isAutogrow) {
            this._$textarea.removeEventListener('input', this._computeHeight);
        }
    }

    initialize() {
        this._addListeners();
        this._toggleActiveClass();
    }

    destroy() {
        this._removeListeners();
    }
}
